export default __webpack_public_path__ + "static/media/logo-mindgrapher-full.61e92e7c.png";